/*
Created by marcin on 2015-09-28 - 11:53.

Dostępne metody:
----------------
ApiNotification.init()
    odpala eventy dla elementów z atrybutem [data-toast] i [data-dialog]. Dla elementów data-toast odpalają metodę notify.
    Dla elementów data-dialog odpalają funkcję dialog.

ApiNotification.dialog(title, message, type, cancelButton, confirmButtonColor, confirmButtonText, cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect)
    Pokazuje okienko typu dialog

ApiNotification.notify(from, align, icon, type, animIn, animOut, message, title)
    Pokazuje element notify w prawym górnym rogu

*/
class ApiNotification {
    static init() {
        ApiNotification.bindEvents();
        ApiNotification.#autoToasts();
    };

    static dialog(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect) {
        if ($.isFunction(swal)) {
            swal({
                    title: _title,
                    text: message,
                    type: _type,
                    showCancelButton: cancelButton,
                    confirmButtonColor: _confirmButtonColor,
                    confirmButtonText: _confirmButtonText,
                    cancelButtonText: _cancelButtonText,
                    closeOnConfirm: false,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (redirect === 0 || typeof redirect === 'undefined') {
                        if (isConfirm) {
                            swal(afterConfirmTitle, afterConfirmMessage, "success");
                        }
                    } else {
                        if (isConfirm) {
                            location.href = redirect;
                        }
                    }
                }
            );
        } else {
            console.log('Swal plugin not include -> http://t4t5.github.io/sweetalert/');
            return false;
        }
    }

    static notify(options, align, icon, type, animIn, animOut, _message, _title, _delay, _timer) {
        let from;

        if (typeof options === 'object') {
            from = options?.from;
            align = options?.align;
            icon = options?.icon;
            type = options?.type;
            animIn = options?.animIn;
            animOut = options?.animOut;
            _message = options?._message;
            _title = options?._title;
            _delay = options?._delay;
            _timer = options?._timer;
        } else {
            from = options;
        }

        if ($.isFunction($.growl)) {
            $.growl({
                    icon: icon,
                    title: _title,
                    message: _message,
                    url: ''

                },
                {
                    element: 'body',
                    type: type,
                    allow_dismiss: true,
                    placement: {
                        from: from,
                        align: align
                    },
                    offset: {
                        x: 20,
                        y: 85
                    },
                    spacing: 10,
                    z_index: 1031,
                    delay: typeof(_delay) === 'undefined' ? 3500 : _delay,
                    timer: typeof(_timer) === 'undefined' ? 1000 : _timer,
                    url_target: '_blank',
                    mouse_over: false,
                    animate: {
                        enter: animIn,
                        exit: animOut
                    },
                    icon_type: 'class',
                    template: '<div data-growl="container" class="alert" role="alert">' +
                        '<button type="button" class="close" data-growl="dismiss">' +
                        '<span aria-hidden="true">&times;</span>' +
                        '<span class="sr-only">Close</span>' +
                        '</button>' +
                        '<span data-growl="icon"></span>' +
                        '<span data-growl="title"></span>' +
                        '<span data-growl="message"></span>' +
                        '<a href="#" data-growl="url"></a>' +
                        '</div>'
                }
            );
        } else {
            console.log('Growl plugin not include -> https://github.com/ifightcrime/bootstrap-growl/');
            return false;
        }
    }

    static alert(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText){
        if ($.isFunction(swal)) {
            swal({
                title: _title,
                text: message,
                type: _type,
                showCancelButton: cancelButton,
                confirmButtonColor: _confirmButtonColor,
                confirmButtonText: _confirmButtonText,
                cancelButtonText: _cancelButtonText,
                closeOnConfirm: true,
                closeOnCancel: true
            });
        } else {
            console.log('Swal plugin not include -> http://t4t5.github.io/sweetalert/');
            return false;
        }
    }

    static bindEvents() {
        //toast
        $('[data-toast]').click(function (e) {
            e.preventDefault();
            let msg;
            const nFrom = $(this).attr('data-from');
            const nAlign = $(this).attr('data-align');
            const nIcons = $(this).attr('data-icon');
            const nType = $(this).attr('data-type');
            const nAnimIn = $(this).attr('data-animation-in');
            const nAnimOut = $(this).attr('data-animation-out');
            const ttl = $(this).attr('data-title');

            msg = $(this).attr('data-message');

            if (msg === 0 || typeof msg === 'undefined') {
                msg = 'Akcja zakończona sukcesem';
            }

            ApiNotification.notify(nFrom, nAlign, nIcons, nType, nAnimIn, nAnimOut, msg, ttl);
        });

        //dialog
        $('[data-dialog]').click(function (e) {
            e.preventDefault();

            let _title = $(this).attr('data-title');
            const message = $(this).attr('data-message');
            const _type = $(this).attr('data-type');
            const cancelButton = $(this).attr('data-cancel-button');
            const _confirmButtonColor = $(this).attr('data-confirm-button-color');
            const _confirmButtonText = $(this).attr('data-confirm-button-text');
            const _cancelButtonText = $(this).attr('data-cancel-button-text');
            let afterConfirmTitle = $(this).attr('data-after-confirm-title');
            let afterConfirmMessage = $(this).attr('data-after-confirm-message');
            const redirect = $(this).attr('data-redirect');

            if (_title === 0 || typeof _title === 'undefined') {
                _title = "Czy na pewno chcesz wykonać akcję?";
            }
            if (afterConfirmTitle === 0 || typeof afterConfirmTitle === 'undefined') {
                afterConfirmTitle = "Sukces!";
            }
            if (afterConfirmMessage === 0 || typeof afterConfirmMessage === 'undefined') {
                afterConfirmMessage = "";
            }

            ApiNotification.dialog(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect);
        });

        //alert
        $('[data-alert]').click(function(e) {
            e.preventDefault();

            let _title = $(this).attr('data-title');
            const message = $(this).attr('data-message');
            const _type = $(this).attr('data-type');
            const cancelButton = $(this).attr('data-cancel-button');
            const _confirmButtonColor = $(this).attr('data-confirm-button-color');
            const _confirmButtonText = $(this).attr('data-confirm-button-text');
            const _cancelButtonText = $(this).attr('data-cancel-button-text');

            if (_title === 0 || typeof _title === 'undefined') {
                _title = "Czy na pewno chcesz wykonać akcję?";
            }

            ApiNotification.alert(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText);
        });
    }

    static #autoToasts() {
        $('.toasts > *').each(function() {
            const msg = $(this).html();
            const ttl = '';
            const nFrom = $(this).attr('data-from');
            const nAlign = $(this).attr('data-align');
            const nIcons = $(this).attr('data-icon');
            const nType = 'success';
            const nAnimIn = $(this).attr('data-animation-in');
            const nAnimOut = $(this).attr('data-animation-out');

            ApiNotification.notify(nFrom, nAlign, nIcons, nType, nAnimIn, nAnimOut, msg, ttl);
        });
    }
}
